import { RootState } from '../index';
import { createDraftSafeSelector } from '@reduxjs/toolkit';
import { AD, roleRestricted, SA } from '../../components/RoleRestricted/utils';

const getUserRole = (state: RootState) =>
  state.userData.userData.expansionUserRole;
const getUserCountries = (state: RootState) =>
  state.userData.userData.countries;
const getUserEmail = (state: RootState) => state.userData.userData.email;
const user = (state: RootState) => state.userData.userData;
const getUserPermissions = (state: RootState) =>
  state.userData.userData.permissions;
const getSelectedCountryID = () => 'en';
const selectUserRole = createDraftSafeSelector(getUserRole, (role) => role);
const selectUserCountries = createDraftSafeSelector(
  getUserCountries,
  (countries) => countries,
);
const selectUserEmail = createDraftSafeSelector(getUserEmail, (email) => email);
const selectSelectedCountryObject = createDraftSafeSelector(
  getSelectedCountryID,
  (selectedId) => selectedId,
);
const selectSelectedLanguage = createDraftSafeSelector(
  selectSelectedCountryObject,
  (object) => object,
);
const selectUser = createDraftSafeSelector(user, (user) => user);

const selectUserPermissions = createDraftSafeSelector(
  getUserPermissions,
  (permissions) => permissions,
);

const selectConfidentialPermission = createDraftSafeSelector(
  selectUserRole,
  (role) => roleRestricted([AD, SA], role),
);

export {
  selectUserRole,
  selectUserCountries,
  selectUserEmail,
  selectSelectedLanguage,
  selectSelectedCountryObject,
  selectUser,
  selectUserPermissions,
  selectConfidentialPermission,
};
